import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { HStack, VStack } from 'native-base';
import FormInput from '../../../../shared/components/common/FormInput';
import AppText from '../../../../shared/components/common/AppText';
import CustomCheckbox from '../../../../shared/components/common/CustomCheckbox';
import AdvanceSelect from '../../../../shared/components/common/AdvanceSelect';
import SharedTimepicker from '../../../../shared/components/common/SharedTimepicker';
import { t } from '../../../../shared/services/i18n';
import { Colors } from '../../../../shared/styles/Colors';
import { GlobalStyleAttributes } from '../../../../shared/styles/GlobalStyles';
import { dbDateFormat, onlyCoaches } from '../../../../shared/services/Helpers';
import { fetchApi } from '../../../../shared/services/HTTP';
import { checkRequired } from '../../../../shared/services/stepperService';
import orderBy from 'lodash-es/orderBy';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

const SendDoctorJournalReport = (props) => {
    const { setFieldValue, values, touched, errors, validationObject, handleChange } = props;
    const currentUser = useSelector((state) => state.user.user);
    const staffMembers = useSelector((state) => state.box.box?.staffMembers);
    const coaches = useMemo(() => orderBy(staffMembers?.filter(onlyCoaches).map(c => ({ value: c.id, label: `${c.first_name || ''} ${c.last_name || ''}`.trim(), email: c.email })), ['label'], ['asc']), [staffMembers]);


    useEffect(() => {
        if (coaches.some(c => c.value === currentUser.id)) {
            setFieldValue('coach_ub_id', currentUser.id)
            setFieldValue('primaryEmail', currentUser.email)
        }
    }, []);

    return (
        <VStack space="1.5rem">
            <FormInput width="100%" label={t('doctorJournalExplanationLabel')} containerProps={{ mb: 0 }}>
                <AppText variant={GlobalStyleAttributes.textVariants.heading3}>{t('doctorJournalExplanation')}</AppText>
            </FormInput>
            <FormInput
                label={t('doctorJournalExportStaff') + checkRequired('coach_ub_id', validationObject)}
                width="100%"
                error={touched.coach_ub_id && errors.coach_ub_id ? errors.coach_ub_id : null}
            >
                <AdvanceSelect
                    dontSort
                    hideCreateBtn
                    options={coaches}
                    initValue={values.coach_ub_id}
                    onChange={(option) => (setFieldValue('coach_ub_id', option?.value) | setFieldValue('primaryEmail', option?.email))}
                    isError={touched.coach_ub_id && errors.coach_ub_id}
                />
            </FormInput>
            <HStack space="1rem" alignItems="flex-start" flexWrap="wrap">
                <FormInput
                    label={t('start-date') + checkRequired('fromDate', validationObject)}
                    width="100%"
                    containerProps={{ flex: 1, minWidth: '140px', mb: 0 }}
                    error={touched.fromDate && errors.fromDate ? errors.fromDate : null}
                >
                    <SharedTimepicker
                        type="date"
                        value={values.fromDate ? moment(values.fromDate, dbDateFormat) : null}
                        onChange={(date) => setFieldValue('fromDate', date ? date.format(dbDateFormat) : '')}
                        textStyle={{ fontSize: GlobalStyleAttributes.fonts.standard16 }}
                        isError={touched.fromDate && errors.fromDate}
                    />
                </FormInput>
                <FormInput
                    label={t('end-date') + checkRequired('toDate', validationObject)}
                    width="100%"
                    containerProps={{ flex: 1, minWidth: '140px', mb: 0 }}
                    error={touched.toDate && errors.toDate ? errors.toDate : null}
                >
                    <SharedTimepicker
                        type="date"
                        value={values.toDate ? moment(values.toDate, dbDateFormat) : null}
                        onChange={(date) => setFieldValue('toDate', date ? date.format(dbDateFormat) : '')}
                        textStyle={{ fontSize: GlobalStyleAttributes.fonts.standard16 }}
                        isError={touched.toDate && errors.toDate}
                    />
                </FormInput>
            </HStack>
            <FormInput width="100%" containerProps={{ mb: 0 }}>
                <CustomCheckbox text={t('doctorJournalExportHideClientName')} isChecked={values.hideClientName} onChange={(v) => setFieldValue('hideClientName', v)} />
            </FormInput>
            <VStack space="0.5rem">
                <FormInput width="100%" label={t('export-as') + '*'} error={(touched.pdf && errors.pdf) ? errors.pdf : null}>
                    <CustomCheckbox isChecked={values.csv} onChange={(val) => setFieldValue('csv', val)} text={t('csv-option')} />
                    <CustomCheckbox isChecked={values.pdf} onChange={(val) => setFieldValue('pdf', val)} text={t('pdf-option')} />
                </FormInput>
            </VStack>
            <FormInput
                infoTooltip={t('doctorJournalExportPrimaryEmailTooltip')}
                label={t('doctorJournalExportPrimaryEmail') + checkRequired('primaryEmail', validationObject)}
                value={values.primaryEmail}
                name="primaryEmail"
                onChangeCallback={handleChange('primaryEmail')}
                error={(touched.primaryEmail && errors.primaryEmail) ? errors.primaryEmail : null}
                containerProps={{ mb: 0 }}
                width="100%"
                type="email"
                placeholder={t('doctorJournalExportPrimaryEmailPlaceholder')}
            />
            <FormInput
                infoTooltip={t('bcc-info')}
                label={t('bcc')}
                value={values.bcc}
                name="bcc"
                onChangeCallback={handleChange('bcc')}
                error={(touched.bcc && errors.bcc) ? errors.bcc : null}
                containerProps={{ mb: 0 }}
                width="100%"
                type="email"
                placeholder={t('your-email')}
            />
            <FormInput width="100%" label={t('doctorJournalExportLabel')} error={(touched.declarationAccepted && errors.declarationAccepted) ? errors.declarationAccepted : null}>
                <AppText variant={GlobalStyleAttributes.textVariants.heading3}>{t('doctorJournalExportDeclaration')}</AppText>
                <CustomCheckbox
                    text={t('doctorJournalExportAgreement')}
                    isChecked={values.declarationAccepted}
                    onChange={(v) => setFieldValue('declarationAccepted', v)}
                />
            </FormInput>
        </VStack>
    );
};

export default SendDoctorJournalReport;
